// generated by genversion
export var version = '4.7.1';
//# sourceMappingURL=version.js.map